import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core'
import {TableRecord} from '../../../../../../../__generated__/datocms.types'

@Component({
  selector: 'bgo-dato-table',
  styleUrl: 'dato-table.component.css',
  templateUrl: './dato-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatoTableComponent implements OnInit {
  @Input({required: true}) tableData!: Pick<TableRecord, 'tableContent'>
  columns: string[] = []
  tableContent: Record<string, string>[] = []

  ngOnInit() {
    this.columns = this.tableData.tableContent.columns
    this.tableContent = this.tableData.tableContent.data
  }
}
